<template>
  <a-layout-content>
    <a-table size="default" row-key="ID" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" :loading="loading" :columns="columns" :data-source="data" :pagination="false" bordered>
      <template slot="title">
        <a-row :gutter="24">
          <a-col :span="5"> 回收真人等级列表 </a-col>
          <a-col style="float: right">
            <a href="javascript:;" @click="qryListAPI()">
              <a-button type="primary"><a-icon type="reload"></a-icon></a-button>
            </a>
            <a href="javascript:;" @click="onAdd()">
              <a-button type="primary"><a-icon type="plus"></a-icon>新增回收等级</a-button>
            </a>
            <a href="javascript:;" @click="BatchDelete()">
              <a-button type="danger"><a-icon type="delete"></a-icon>批量删除</a-button>
            </a>
            <a href="javascript:;" @click="AllDelete()">
              <a-button type="danger"><a-icon type="delete"></a-icon>删除所有</a-button>
            </a>
          </a-col>
        </a-row>
      </template>
      <template slot="operate" slot-scope="text, record">
        <template>
          <a-tooltip>
            <template slot="title"> 修改 </template>
            <a href="javascript:;" @click="onEdit(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
        <template>
          &nbsp;
          <a-tooltip>
            <template slot="title"> 删除 </template>
            <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
              <a href="javascript:;">
                <a-icon type="delete" style="font-size: 22px"></a-icon>
              </a>
            </a-popconfirm>
          </a-tooltip>
        </template>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination style="float: right" show-size-changer :default-current="pagination.current"
        :total="pagination.total" :show-total="(total) => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange" @showSizeChange="sizeChange" />
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="编辑" @ok="modalOk">
      <a-form-model :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="等级">
          <a-input v-model="formModel.Grade" placeholder="真人等级" />
        </a-form-model-item>
        <a-form-model-item label="回收金额">
          <a-input v-model="formModel.Money" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input v-model="formModel.Sort" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>

  export default {
    data() {
      return {
        UserID: sessionStorage.UserID,
        visible: false, //弹框状态
        formModel: {}, // 弹框字段
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        data: [],
        columns: [
          {
            title: "ID",
            dataIndex: "ID",
            align: "center",
          },
          {
            title: "等级",
            dataIndex: "Grade",
            align: "center",
          },
          {
            title: "回收金额",
            dataIndex: "Money",
            align: "center",
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          sizeList: ["10", "20", "30", "40", "50"],
        },
        selectedRowKeys: [], // 勾选此处配置默认列
        loading: false,
        form: { Status: "1", Sorte: "0" },
        borrowPolling: undefined,
      };
    },
    methods: {
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      //  分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      // 搜索
      search() {
        this.pagination.current = 1;
        this.qryListAPI();
      },
      // 查询API
      qryListAPI() {
        this.loading = true;
        this.axios
          .post("/AccountTrans/GetLiveGradeRecycleSetList", {
            Type: 2,
            pageindex: this.pagination.current,
            pagesize: this.pagination.pageSize,
          })
          .then((res) => {
            if (res.data) {
              this.pagination.total = res.total;
              this.loading = false;
              this.data = res.data;
            }
          });
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      // 编辑
      onEdit(data) {
        this.visible = true;
        this.formModel = { ...data };
      },
      // 新增弹框按钮
      onAdd() {
        this.visible = true;
        this.formModel = {};
      },
      // 删除
      onDelete(data) {
        this.axios
          .post("/Accounttrans/DeleteLiveGradeRecycleSet",
            {
              IDList: [{ ID: data.ID }],
              GsType: 2,
              Type: 1
            })
          .then((res) => {
            if (res.data) {
              this.$message.success("删除成功");
              this.qryListAPI();
            }
          });
      },
      // 勾选删除
      BatchDelete() {
        console.log(this.selectedRowKeys.length);
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量删除",
          content: "您要确定要删除勾选数据吗?",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/AccountTrans/BatchDeleteLiveGradeRecycleSet", {
                IDList: idList,
                GsType: 2,
                Type: 1
              })
              .then((res) => {
                if (res.data) {
                  that.selectedRowKeys = [];
                  that.$message.success("删除成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 删除所有
      AllDelete() {
        const that = this;
        this.$confirm({
          title: "删除所有",
          content: "您要确定要删除所有数据吗?",
          onOk() {
            that.axios.post("/AccountTrans/AllDeleteLiveGradeRecycleSet",
              {
                IDList: [],
                GsType: 2,
                Type: 2
              }).then((res) => {
                if (res.data) {
                  that.selectedRowKeys = [];
                  that.$message.success("删除成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 编辑确认
      modalOk() {
        this.formModel.Type = 2;
        // 弹框确认动作
        this.axios.post("/AccountTrans/SaveLiveGradeRecycleSet", this.formModel).then((res) => {
          if (res.data) {
            this.$message.success("编辑成功");
            this.qryListAPI();
            this.visible = false;
          }
        });
      },
      UserRoute(obj) {
        this.$router.push({
          name: "user",
          params: {
            name: "user",
            userid: obj,
          },
        });
      },
    },

    //首次加载
    created() {
      this.qryListAPI();
    },
  };
</script>

<style>
  .fontred {
    color: #ff4d4f;
    font-size: 15px;
    font-weight: 600;
  }
</style>


// WEBPACK FOOTER //
// src/components/accounttransaction/liverankreclaim.vue